<script>
import _ from 'lodash'
import Modal from '../Modal'
import RadioGroup from '../slds/RadioGroup'
import TabSet from '../slds/tabs/TabSet'
import Tab from '../slds/tabs/Tab'

export default {
  components: {
    Modal,
    RadioGroup,
    Tab,
    TabSet
  },
  created () {
    const recordTypes = this.$store.getters['settings/settings'].campaignRecordTypes

    const types = _.sortBy(Object.entries(recordTypes).map(([key, options]) => {
      return {
        id: options.id,
        label: this.$t(`campaignDesigner.campaignsList.${key}Campaign`),
        section: options.section,
        value: key,
        onlyHeader: options.onlyHeader
      }
    }), ['id'])

    this.types = types.reduce((acc, val) => {
      if (!acc[val.section]) {
        acc[val.section] = [ val ]
      } else {
        acc[val.section].push(val)
      }
      return acc
    }, {})


    this.type = Object.values(this.types)[0][0].value
    if (Object.values(this.types)[0].length === 1 && Object.values(Object.values(this.types)[0]).length === 1) {
      this.$emit('create', { type: this.type })
    }
  },
  data () {
    return {
      types: [],
      type: ''
    }
  }
}
</script>
<template>
  <Modal
    @close="$emit('close')"
    @neutralButtonClick="$emit('close')"
    @positiveButtonClick="$emit('create', { type })"
    :title="$t('campaignDesigner.campaignsList.newCampaign')"
    :positive-button-text="$t('general.next')"
    :neutral-button-text="$t('action.cancel')"
    v-if="Object.values(types) && Object.values(types)[0].length > 1">
    <tab-set type="vertical" tab-set-id="campaign-record-type">
      <tab v-for="(section, index) in Object.keys(types)" :key="section" :position="`${index}`" :index="index" tab-set-id="campaign-record-type" :label="section">
        <radio-group :options="types[section]" v-model="type" :label="$t('campaignDesigner.campaignsList.selectCampaignType')" class="slds-p-left--small" />
      </tab>
    </tab-set>

  </Modal>
</template>
<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;

  & > div {
    flex-grow: 1;
  }
}

.label {
  float: right;
}
</style>
